import {
  DialogContent, Dialog, Button, DialogTitle, Typography, Grid, DialogActions,
} from '@material-ui/core';
import GetApp from '@material-ui/icons/GetApp';
import React from 'react';
import PropTypes from 'prop-types';

function openFile(id, fileType, from, to) {
  let timeFrame = '';
  if (from && to) {
    timeFrame = `&from=${from}&to=${to}`;
  }
  // eslint-disable-next-line no-unused-expressions
  window.open(`${window.location.origin}/idp-auth/pbasen/admin/ExportCommittee?id=${id}&format=${fileType}${timeFrame}`, '_blank').opener;
}

const ExportDialog = ({ id, open, closeDialog, from, to }) => (
  <Dialog open={open} onClose={() => closeDialog()}>
    <DialogTitle>Eksporter utvalg</DialogTitle>
    <DialogContent>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          {from && to && (<Typography variant="body1">Oversikt over tidligere og nåværende medlemmer i utvalget fra {from} til {to}</Typography>)}
          {!from && !to && (<Typography variant="body1">Oversikt over tidligere og nåværende medlemmer i utvalget</Typography>)}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            fullWidth
            variant="outlined"
            endIcon={<GetApp />}
            color="primary"
            onClick={() => {
              openFile(id, 'csv', from, to);
              closeDialog();
            }}
          >
            CSV
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            fullWidth
            variant="outlined"
            endIcon={<GetApp />}
            color="primary"
            onClick={() => {
              openFile(id, 'pdf', from, to);
              closeDialog();
            }}
          >
            PDF
          </Button>
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => closeDialog()}>Avbryt</Button>
    </DialogActions>
  </Dialog>
);

ExportDialog.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func,
  from: PropTypes.string,
  to: PropTypes.string,
};

ExportDialog.defaultProps = {
  closeDialog: () => {},
  from: undefined,
  to: undefined,
};

export default ExportDialog;
